/**
 * The bottom bar's four destinations (V3-w; decision Q18), in DOM order.
 *
 * The order is the Persian one, read right to left: profile, leaderboard,
 * home, library. In an RTL document the first item sits at the right edge,
 * and the English interface simply mirrors — same DOM order, rendered
 * left to right — so there is one list and the document direction does
 * the flipping (src/i18n sets `dir` from the language).
 *
 * `key` doubles as the label's translation key under `common:nav.*`.
 */
export const NAV_ITEMS = [
  { key: 'profile', to: '/profile', match: ['/profile'] },
  { key: 'leaderboard', to: '/leaderboard', match: ['/leaderboard'] },
  { key: 'home', to: '/dashboard', match: ['/dashboard'] },
  // The library is the staged path since V7-w, with the flat catalogue
  // under it at `/lessons/all`; a lesson being practised still belongs to
  // the library, so `/lesson/:id` lights the same tab as `/lessons`.
  { key: 'library', to: '/lessons', match: ['/lessons', '/lesson'] },
]

/**
 * Whether `pathname` belongs to a tab: the tab's own path or anything under
 * it (`/profile/edit` is still the profile). Prefix matching stops at a
 * path boundary so `/lessonsx` would not count.
 */
export function isNavActive(item, pathname) {
  return item.match.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
}

/** The tab `pathname` falls under, or null off the four (settings, the feed, the archive…). */
export function activeNavKey(pathname) {
  return NAV_ITEMS.find((item) => isNavActive(item, pathname))?.key ?? null
}
